import { Add } from '@wix/wix-ui-icons-common';
import { Button, HoverStyles, PaddingModes } from '@wix/wix-ui-tpa/cssVars';
import React, { useEffect, useRef } from 'react';
import { classes, st } from './FileUpload.st.css';
import { useId } from '../../../../hooks/use-id';
import { useFocusFieldEvent } from '../../../../contexts/events-context';
export const FileUpload = _ref => {
  let {
    fieldId,
    inputId,
    fileInputRef,
    fileUploadButtonRef,
    textBelowButtonRef,
    accept,
    files,
    multiple = false,
    buttonText,
    onChange,
    onFocus,
    onBlur,
    className,
    disabled,
    ariaRoleDescription,
    ariaDescribedBy,
    ariaLabelledBy,
    required
  } = _ref;
  const [checkErrorFocus, setCheckErrorFocus] = React.useState(false);
  const dialogOpenRef = React.useRef(false);
  const fileHasError = Boolean(files == null ? void 0 : files.find(file => file.state === 'error'));
  const filesExist = files && Boolean(files.length);
  const textBellowButton = textBelowButtonRef.current;
  const buttonTextId = useId();
  const buttonTextRef = useRef(null);
  useEffect(() => {
    const listener = () => {
      dialogOpenRef.current = false;
      handleFileChange(new FileList());
    };
    const inputEl = fileInputRef.current;
    if (inputEl) {
      inputEl.addEventListener('cancel', listener);
    }
    return () => {
      inputEl == null || inputEl.removeEventListener('cancel', listener);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileInputRef.current]);
  useEffect(() => {
    if (buttonTextRef.current) {
      buttonTextRef.current.id = buttonTextId;
    }
  }, [buttonTextId]);
  const ariaLabelledByIds = [ariaLabelledBy, buttonTextId].filter(Boolean).join(' ');
  const handleFileChange = _files => {
    textBelowButtonRef.current = null;
    onChange == null || onChange(_files);
    dialogOpenRef.current = false;
    setCheckErrorFocus(true);
  };
  const clickHandler = React.useCallback(() => {
    var _fileInputRef$current;
    dialogOpenRef.current = true;
    (_fileInputRef$current = fileInputRef.current) == null || _fileInputRef$current.click();
  }, [fileInputRef]);
  React.useEffect(() => {
    if (checkErrorFocus && filesExist && fileHasError && textBellowButton) {
      textBellowButton.focus();
      setCheckErrorFocus(false);
    }
  }, [checkErrorFocus, filesExist, fileHasError, textBellowButton]);
  useFocusFieldEvent(() => {
    var _fileUploadButtonRef$;
    (_fileUploadButtonRef$ = fileUploadButtonRef.current) == null || _fileUploadButtonRef$.focus({
      preventScroll: true
    });
  }, fieldId);
  const handleInputChange = e => {
    handleFileChange(e.currentTarget.files);

    // allows re-selecting same field again
    e.target.value = '';
  };
  function handleBlur(e) {
    if (dialogOpenRef.current) {
      dialogOpenRef.current = false;
      return;
    }
    onBlur == null || onBlur(e);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: st(classes.root, className),
    "data-hook": "file-upload-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.mainContainer
  }, /*#__PURE__*/React.createElement("input", {
    className: classes.input,
    ref: fileInputRef,
    type: "file",
    accept: accept,
    onChange: handleInputChange,
    multiple: multiple
  }), /*#__PURE__*/React.createElement(Button, {
    hoverStyle: HoverStyles.underline,
    className: classes.button,
    id: inputId,
    ref: fileUploadButtonRef,
    contentRef: buttonTextRef,
    contentClassName: classes.buttonText,
    paddingMode: PaddingModes.explicitPaddings,
    onClick: clickHandler,
    onFocus: onFocus,
    onBlur: handleBlur,
    disabled: disabled,
    prefixIcon: /*#__PURE__*/React.createElement(Add, {
      "aria-hidden": "true"
    }),
    "aria-roledescription": ariaRoleDescription,
    "aria-labelledby": ariaLabelledByIds,
    "aria-describedby": ariaDescribedBy,
    "aria-required": required
  }, buttonText)));
};
FileUpload.displayName = 'FileUpload';
//# sourceMappingURL=FileUpload.js.map